interface FindIdResultProps {
  foundEmail: string;
  onGoToLogin: () => void;
  className?: string;
}

export function FindIdResult({ 
  foundEmail, 
  onGoToLogin,
  className = '' 
}: FindIdResultProps) {
  
  if (!foundEmail) {
    return null;
  }

  return (
    <div className={`text-center space-y-6 ${className}`}>
      {/* 성공 아이콘 */}
      <div className="flex justify-center mb-6">
        <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center">
          <svg className="w-8 h-8 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
          </svg>
        </div>
      </div>

      {/* 결과 메시지 */}
      <div className="mb-6">
        <h3 className="text-[20px] font-semibold text-[#222222] mb-3">
          아이디를 찾았습니다!
        </h3>
        <p className="text-[16px] text-gray-600 mb-4">
          가입하신 아이디는 다음과 같습니다
        </p>
        
        {/* 찾은 아이디 표시 */}
        <div className="bg-gray-50 border border-gray-200 rounded-lg p-4 mb-6">
          <div className="text-[18px] font-medium text-[#222222] break-all">
            {foundEmail}
          </div>
        </div>
      </div>

      {/* 로그인 버튼 */}
      <button
        onClick={onGoToLogin}
        className="w-full h-[50px] bg-[#51C854] text-white font-semibold text-[16px] rounded-xl hover:bg-[#46B649] transition-colors"
      >
        로그인하러 가기
      </button>
    </div>
  );
}